import { render, staticRenderFns } from "./PopoverMessageEdit.vue?vue&type=template&id=bfbfd36e&"
import script from "./PopoverMessageEdit.vue?vue&type=script&lang=js&"
export * from "./PopoverMessageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PopoverMessageEdit.vue"
export default component.exports